import { NavigateFunction } from "react-router-dom";
import { LoginResponse } from "@/api/auth";
export function LoginDecider(navigate: NavigateFunction, response: LoginResponse) {
    if (response.role.toLowerCase() === "client") {
        navigate('/clients/projects')
    } else if (!response.onboarding_completed) {
        navigate('/employees/onboarding')
    } else {
        navigate('/main_menu')
    }
}